import {
  Progress,
  Box,
  Flex,
  Text,
  useColorModeValue,
  Spacer,
  Spinner
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import React from "react";

export default function ProgressStats({ data, showSpinner = false }) {

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const statColor = useColorModeValue("secondaryGray.700", "white");
  return (
    <Card align='center' direction='column' w='100%'>
      <Flex justify='space-between' mb='20px' align='center'>
        <Text
          color={textColor}
          fontSize='22px'
          fontWeight='700'
          lineHeight='100%'>
          Statistics
        </Text>
      </Flex>
      {showSpinner ? <Spinner /> : <Box h='100%' mt='auto'>
        {
          data.map((v) =>
            <>
              <Box>
                <Flex align='center' w='100%' py='5px' >
                  <Text
                    align='left'
                    color={statColor}
                    fontSize='lg'
                    fontWeight='700'>
                    {v.telco}
                  </Text>
                  <Spacer />
                  <Text
                    me='auto'
                    color={statColor}
                    fontSize='lg'
                    fontWeight='700'
                    lineHeight='100%'>
                    {v.stat[0].toLocaleString('en-US')}
                  </Text>
                </Flex>
                <Box align='left'>
                  <Progress value={v.stat[1]} w='100%' size='xs' colorScheme={v.color} />
                </Box>
              </Box>
              <br />
            </>
          )
        }
      </Box>
      }
    </Card>

  );
}

